// src/components/NovitaNexiora.js
// «Cosa c'è di nuovo»: le novità dell'ultimo aggiornamento, una volta per dispositivo
// (utils/novita.js). Non compare a chi ha l'account più recente delle novità, né sopra
// la prima configurazione (onboarding) o la guida.
import React, { useState } from "react";
import { ultimaNovita, novitaGiaVista, segnaNovitaVista } from "../utils/novita";
import { useAuth } from "../contexts/AuthContext";

const dataDi = (v) => { try { return v?.toDate ? v.toDate() : v ? new Date(v) : null; } catch { return null; } };

export default function NovitaNexiora({ onNavigate, nascosto }) {
  const { userProfile } = useAuth();
  const novita = ultimaNovita();
  const [chiusa, setChiusa] = useState(() => !novita || novitaGiaVista(novita.id));
  if (!novita || chiusa || nascosto || !userProfile) return null;
  const creato = dataDi(userProfile.createdAt);
  if (creato && creato >= new Date(novita.id + "T23:59:59")) { segnaNovitaVista(novita.id); return null; }
  const chiudi = () => { segnaNovitaVista(novita.id); setChiusa(true); };
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && chiudi()} style={{ zIndex: 9000 }}>
      <div className="modal" style={{ maxWidth: 520, maxHeight: "88vh", overflowY: "auto", padding: 0 }}>
        {/* intestazione chiara con bordo viola, come gli altri messaggi informativi (AvvisoViola) */}
        <div style={{ background: "#faf5ff", color: "#5b21b6", padding: "16px 22px", borderRadius: "12px 12px 0 0", borderBottom: "1px solid #ede9fe", borderLeft: "4px solid #7c3aed" }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#7c3aed" }}>Aggiornamento</div>
          <div style={{ fontSize: 18, fontWeight: 800 }}>✨ {novita.titolo}</div>
        </div>
        <div style={{ padding: "14px 22px 6px" }}>
          {novita.voci.map((v, i) => (
            <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start", padding: "10px 0", borderBottom: i < novita.voci.length - 1 ? "1px solid #f3f4f6" : "none" }}>
              <span style={{ fontSize: 20, lineHeight: 1.2 }}>{v.icona}</span>
              <div style={{ flex: 1, fontSize: 13, color: "#374151", lineHeight: 1.5 }}>
                {v.testo}
                {v.vai && onNavigate && (
                  <button type="button" onClick={() => { chiudi(); onNavigate(v.vai); }}
                    style={{ display: "block", marginTop: 4, background: "none", border: "none", padding: 0, color: "#7c3aed", fontWeight: 700, fontSize: 12, cursor: "pointer", fontFamily: "'Inter',sans-serif" }}>
                    {v.etichetta || "Apri"} →
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <div style={{ padding: "8px 22px 18px", display: "flex", justifyContent: "flex-end" }}>
          <button type="button" className="btn btn-primary" onClick={chiudi}>Ho capito</button>
        </div>
      </div>
    </div>
  );
}
